import { c as _c } from "react/compiler-runtime";
import AccountTree from "@mui/icons-material/AccountTree";
import DataArray from "@mui/icons-material/DataArray";
import DataObject from "@mui/icons-material/DataObject";
import GridOn from "@mui/icons-material/GridOn";
import Link from "@mui/icons-material/Link";
import ListAlt from "@mui/icons-material/ListAlt";
import LooksOne from "@mui/icons-material/LooksOne";
import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import SettingsEthernet from "@mui/icons-material/SettingsEthernet";
import TextFields from "@mui/icons-material/TextFields";
import Timeline from "@mui/icons-material/Timeline";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, type SelectProps, type SxProps, useTheme } from "@mui/material";
import React from "react";
import { ArgumentType } from "#/entities/argument/model/argumentObject";
import { argumentTypeLabels } from "#/entities/argument/model/argumentTypeLabels";
import { useI18nContext } from "#/shared/hooks";
type ArgumentTypeSelectProps = Omit<SelectProps, "value" | "onChange" | "variant"> & {
  value: ArgumentType;
  onChange: (value: ArgumentType) => void;
};
const iconSxProps: SxProps = {
  fontSize: "17px",
  verticalAlign: "text-bottom",
  mr: 1,
  mb: "2px"
};
const typeIconsMap: Record<ArgumentType, React.ReactElement> = {
  [ArgumentType.BINARY_TREE]: <AccountTree sx={iconSxProps} />,
  [ArgumentType.LINKED_LIST]: <Link sx={iconSxProps} />,
  [ArgumentType.GRAPH]: <Timeline sx={iconSxProps} />,
  [ArgumentType.NUMBER]: <LooksOne sx={iconSxProps} />,
  [ArgumentType.MATRIX]: <GridOn sx={iconSxProps} />,
  [ArgumentType.ARRAY]: <DataArray sx={iconSxProps} />,
  [ArgumentType.BOOLEAN]: <RadioButtonChecked sx={iconSxProps} />,
  [ArgumentType.STRING]: <TextFields sx={iconSxProps} />,
  [ArgumentType.SET]: <SettingsEthernet sx={iconSxProps} />,
  [ArgumentType.MAP]: <ListAlt sx={iconSxProps} />,
  [ArgumentType.OBJECT]: <DataObject sx={iconSxProps} />
};
export const ArgumentTypeSelect: React.FC<ArgumentTypeSelectProps> = t0 => {
  const $ = _c(25);
  let onChange;
  let restProps;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = restProps;
    $[3] = value;
  } else {
    onChange = $[1];
    restProps = $[2];
    value = $[3];
  }
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  let t1;
  if ($[4] !== LL) {
    t1 = LL.TYPE();
    $[4] = LL;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <InputLabel>{t1}</InputLabel>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== onChange) {
    t3 = event => onChange(event.target.value as ArgumentType);
    $[8] = onChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== LL) {
    t4 = LL.TYPE();
    $[10] = LL;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== theme.palette.text.primary) {
    t5 = {
      width: "70px",
      "& [role=combobox]": {
        color: "transparent",
        "& > svg": {
          ml: 0.5,
          color: theme.palette.text.primary
        }
      }
    };
    $[12] = theme.palette.text.primary;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.values(ArgumentType).map(_temp);
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== restProps || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== value) {
    t7 = <Select value={value} onChange={t3} label={t4} size="small" sx={t5} {...restProps}>{t6}</Select>;
    $[15] = restProps;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = value;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FormHelperText />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t2 || $[23] !== t7) {
    t9 = <FormControl>{t2}{t7}{t8}</FormControl>;
    $[22] = t2;
    $[23] = t7;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
function _temp(type) {
  return <MenuItem key={type} value={type}>{typeIconsMap[type]} {argumentTypeLabels[type]}</MenuItem>;
}